import CallMade from "@mui/icons-material/CallMade";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import _ from "lodash";
import { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { Controller } from "react-hook-form";
import styled from "styled-components";
import Swal from "sweetalert2";
import { Button } from "../../components";
import { IoCloudUpload } from "react-icons/io5";
import { RiUploadCloud2Fill } from "react-icons/ri";

function FilePicker({
  label,
  name,
  control,
  watch,
  setValue,
  unregister,
  trigger,
  isReadOnly,
  message,
  isRequired,
  filePickerTitle,
}) {
  const [filePreview, setFilePreview] = useState([]);
  const onDrop = useCallback(async (acceptedFiles, rejectedFiles) => {
    if (!_.isEmpty(rejectedFiles)) {
      Swal.fire({
        text:
          rejectedFiles?.[0]?.errors?.[0]?.code === "file-too-large"
            ? "File Size Larger than 5MB"
            : "Please provide .png or .jpeg file format",
        icon: "warning",
        confirmButtonText: "OK",
        confirmButtonColor: "#DC004E",
        reverseButtons: true,
        focusConfirm: false,
        allowOutsideClick: false,
        focusCancel: false,
        scrollbarPadding: false,
      });
      return;
    }
    setFilePreview(() =>
      acceptedFiles.map((file) => URL.createObjectURL(file))
    );
    const base64Promises = acceptedFiles.map(
      (file) =>
        new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = () => {
            const base64String = reader.result.split(",")[1];
            resolve({ file, base64String });
          };
          reader.readAsDataURL(file);
        })
    );

    const base64Files = await Promise.all(base64Promises);

    setValue(name, base64Files);
    trigger([name]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      "image/png": [".png"],
      "image/jpeg": [".jpeg"],
      "image/jpg": [".jpg"],
      "application/pdf": [".pdf"],
    },
    maxSize: 1024 * 1024 * 5,
  });

  const handleRemove = (name) => {
    unregister(name);
    setValue(name, null);
  };

  function isValidURL(text) {
    return !!text;
  }

  const handleRealFilePreview = (url) => {
    if (url) {
      window.open(url, "_blank");
    }
  };
  return (
    <>
      <FilePickerContainerStyled readOnlyStyles={isReadOnly}>
        {/* {!!label && (
          <HeadingStyled>
            {label}{" "}
            {isRequired ? <span className="required-label">*</span> : ""}
          </HeadingStyled>
        )} */}
        <RiUploadCloud2Fill />
        {!isReadOnly ? (
          <FilePickerAreaStyled>
            <Controller
              name={name}
              control={control}
              render={() => (
                <div
                  {...getRootProps()}
                  id="menu_file"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <input {...getInputProps()} />

                  <div style={{ fontSize: "12px" }}>
                    {!!filePickerTitle ? (
                      <p>{filePickerTitle}</p>
                    ) : (
                      <p>Choose a file or drag & drop it here</p>
                    )}
                    <p className="warnings" style={{ paddingLeft: "20px" }}>
                      JPEG, PNG and PDF Formats, upto 2MB
                    </p>
                    {/* <p className="warnings">File Size must be less than 5MB</p> */}
                    <div
                      style={{
                        marginBottom: "5px",
                        border: "1px solid grey",
                        padding: "5px 20px",
                        borderRadius: "8px",
                        fontSize: "12px",
                        width: "fit-content",
                        position: "relative",
                        left: "80px",
                      }}
                    >
                      Browse File
                    </div>
                  </div>
                </div>
              )}
            />
          </FilePickerAreaStyled>
        ) : null}

        <FilePreviewStyled readOnlyStyles={isReadOnly}>
          {Array.isArray(watch(name)) && watch(name)?.length ? (
            <div class="preview_container">
              <div onClick={() => window.open(filePreview, "_blank")}>
                <p className="file_name">
                  {watch(name)?.[0]?.file?.name.length < 25
                    ? watch(name)?.[0]?.file?.name
                    : watch(name)?.[0]?.file?.name.substring(0, 25) + "..."}
                </p>
                <p>{Math.floor(watch(name)?.[0]?.file?.size / 1024)} KB</p>
              </div>
              <p className="cancel_file" onClick={() => handleRemove(name)}>
                X
              </p>
            </div>
          ) : isValidURL(watch(name)) ? (
            <>
              <RealPreviewStyled readOnlyStyles={isReadOnly}>
                <Button
                  bgColor="transparent"
                  textColor="#11555F"
                  id="add_broker"
                  variant="outlined"
                  borderColor="#11555F"
                  endIcon={<CallMade />}
                  onClick={() => handleRealFilePreview(watch(name))}
                >
                  Preview an Uploaded File
                </Button>
                {!isReadOnly && (
                  <p
                    className="cancel_file_in_preview"
                    onClick={() => handleRemove(name)}
                  >
                    X
                  </p>
                )}
              </RealPreviewStyled>
            </>
          ) : (
            <></>
          )}
        </FilePreviewStyled>
      </FilePickerContainerStyled>
    </>
  );
}

export default FilePicker;

const FilePickerAreaStyled = styled.div`
  width: 50%;
  cursor: pointer;
`;

const FilePreviewStyled = styled.div`
  width: ${(props) => (props.readOnlyStyles ? "100%" : "50%")};
  // margin-top: -27px;
  .preview_container {
    position: relative;
    margin-right: 20px;
    border: 0.25px solid;
    border-radius: 5px;
    padding: 5px;
    margin-top: 30px;
    display: flex;
    justify-content: space-around;
    font-size: 16px;
    
    /*  */
    & > div {
      width: 100%;
      display: flex;
      justify-content: space-around;
      height: 33px;
      align-items: center;
      cursor: pointer;
    }

    & > * {
      margin: 0;
    }
    .cancel_file {
      background: #fff;
      position: absolute;
      top: -13px;
      left: 97%;
      border-radius: 50%;
      border: 0.25px solid;
      width: 25px;
      height: 25px;
      text-align: center;
      cursor: pointer;
      font-size: 0.8rem;
      padding-top: 2.5px;
    }
  }
`;

const RealPreviewStyled = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${(props) =>
    props.isInDatagrid || props.readOnlyStyles ? "0" : "30px"};
  margin-right: 20px;
  justify-content: flex-end;
  margin-left: ${(props) => (props.readOnlyStyles ? "10px" : "0")};
  position: relative;
  .cancel_file_in_preview {
    background: rgb(255, 255, 255);
    position: absolute;
    bottom: 10px;
    right: -11px;
    border-radius: 60%;
    border: 0.25px solid;
    width: 25px;
    height: 24px;
    text-align: center;
    cursor: pointer;
    font-size: 16px;
  }
`;

const FilePickerContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-wrap: wrap;
  border: 2px dashed #c4c4c4;
  border-radius: 0.5rem;
  padding: 13px 0;
  margin-top: 5px;
  font-size: 1.25rem;
  margin-bottom: ${(props) => (props.readOnlyStyles ? "10px" : "0")};
  #menu_file {
    display: flex;
    align-items: center;
    p {
      font-size: 18px;
      font-weight: 700;
      
      margin-left: 10px;
    }
    .warnings {
      margin-left: 10px;
      color: grey;
      font-size: 12px;
      margin-top: -10px;
    }
  }
  svg {
    color: #4373eb;
    font-size: 2.5rem;
    margin-left: 10px;
  }
  b {
    color: #4373eb;
    letter-spacing: 0.5px;
    text-decoration: underline;
  }
`;

const HeadingStyled = styled.h3`
  margin: 0 0 5px 14px;
  width: 100%;
  color: rgb(17, 85, 95);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.5px;
  
  span {
    color: red;
    position: relative;
    left: 0px;
    top: -5px;
    font-size: 12px;
  }
`;
